// extracted by mini-css-extract-plugin
export default {"resetPasswordContainer":"ResetPasswordPage_resetPasswordContainer__JYnJL"};